import React from 'react'
import formatMessage from 'format-message'

export default function Error({ errorMessage }) {
  return (
    <div id="error-container">
      <div className="absolute-center panel panel-default">
        <div className="panel-body">
          <div style={{ margin: 'auto', fontSize: '1.8rem' }}>
            <span
              className="error-message"
              dangerouslySetInnerHTML={{
                __html: errorMessage || formatMessage('Oops! Something went wrong.'),
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
